import { render, staticRenderFns } from "./ModalChangeUserMember.vue?vue&type=template&id=b224602c&"
import script from "./ModalChangeUserMember.vue?vue&type=script&lang=js&"
export * from "./ModalChangeUserMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports